/*!

=========================================================
* Black Dashboard React v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Dashboard.js";
import UserProfile from "views/UserProfile.js";

// Import komponen untuk SIO ESA
import PelaporanKeberadaan from "views/PelaporanKeberadaan";
import PelaporanKegiatan from "views/PelaporanKegiatan";
import DataOrmas from "views/DataOrmas";
import UploadDokumen from "views/UploadDokumen";
import UsersSioEsa from "views/UsersSioEsa";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard SIO ESA",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-chart-pie-36",
    component: Dashboard,
    layout: "/admin",
    sidebar: true,
    user: true,
  },
  {
    path: "/pelaporan-keberadaan",
    name: "Pelaporan Keberadaan ORMAS",
    rtlName: "تقرير وجود المنظمات",
    icon: "tim-icons icon-bullet-list-67",
    component: PelaporanKeberadaan,
    layout: "/admin",
    sidebar: true,
    user: true,
  },
  {
    path: "/pelaporan-kegiatan",
    name: "Pelaporan Kegiatan ORMAS",
    rtlName: "تقرير أنشطة المنظمات",
    icon: "tim-icons icon-chart-bar-32",
    component: PelaporanKegiatan,
    layout: "/admin",
    sidebar: true,
    user: true,
  },
  {
    path: "/data-ormas",
    name: "Data ORMAS",
    rtlName: "بيانات المنظمات",
    icon: "tim-icons icon-bank",
    component: DataOrmas,
    layout: "/admin",
    sidebar: true,
    user: true,
  },
  {
    path: "/upload-dokumen",
    name: "Upload Dokumen",
    rtlName: "رفع المستندات",
    icon: "tim-icons icon-upload",
    component: UploadDokumen,
    layout: "/admin",
    sidebar: true,
    user: true,
  },
  {
    path: "/users-sio-esa",
    name: "Users SIO ESA",
    rtlName: "مستخدمي النظام",
    icon: "tim-icons icon-single-02",
    component: UsersSioEsa,
    layout: "/admin",
    sidebar: true,
    user: true,
  },
  {
    path: "/user-profile",
    name: "User Profile",
    rtlName: "ملف تفي للمستخدم",
    icon: "tim-icons icon-badge",
    component: UserProfile,
    layout: "/admin",
    sidebar: true,
    user: true,
  },
];
export default routes;
